import React, { useEffect } from 'react';
import './Skills.css'
import javascript from '../../images/skills-image/javascript.png'
import react from '../../images/skills-image/react.png'
import node from '../../images/skills-image/node.png'
import mongodb from '../../images/skills-image/mongodb.jpg'
import bootstrap from '../../images/skills-image/bootstrap.png'
import git from '../../images/skills-image/git.png'
import html from '../../images/skills-image/html.png'
import firebase from '../../images/skills-image/firebaset.png'
import tailwind from '../../images/skills-image/tailwind.jpg'
import reactRouter from '../../images/skills-image/react-router.png'
import heroku from '../../images/skills-image/heroku.png'
import css from '../../images/skills-image/css.png'
import AOS from 'aos';
import 'aos/dist/aos.css';


const Skills = () => {
    useEffect(() => {
        AOS.init({
            duration: 500,
        })
    }, [])
    return (
        <div id="skills" className='py-5' style={{ background: "#2B3443" }}>
            <div className="container">
                <div>
                    <h1 className="text-center text-white pt-5 pb-3 section-border">
                        My Skill
                    </h1>
                </div>
                <div className="row text-center py-3">
                    <div className="col-md-3"
                        data-aos="fade-right"
                        data-aos-offset="300"
                        data-aos-easing="ease-in-sine"
                        data-aos-duration="400"
                    >
                        <h5 className="text-secondary mb-3">CSS</h5>
                        <img width="100" className="img-fluid skill-hover" src={css} alt="javascript"></img>
                    </div>
                    <div className="col-md-3"
                        data-aos="fade-right"
                        data-aos-offset="300"
                        data-aos-easing="ease-in-sine"
                        data-aos-duration="600"
                    >
                        <h5 className="text-secondary mb-3">React</h5>
                        <img width="100" className="img-fluid skill-hover" src={react} alt="javascript"></img>
                    </div>
                    <div className="col-md-3"
                        data-aos="fade-right"
                        data-aos-offset="300"
                        data-aos-easing="ease-in-sine"
                        data-aos-duration="800"
                    >
                        <h5 className="text-secondary mb-3">Node js</h5>
                        <img width="100" className="img-fluid skill-hover" src={node} alt="javascript"></img>
                    </div>
                    <div className="col-md-3"
                        data-aos="fade-right"
                        data-aos-offset="300"
                        data-aos-easing="ease-in-sine"
                        data-aos-duration="900"
                    >
                        <h5 className="text-secondary mb-3">Javascript</h5>
                        <img width="100" className="img-fluid skill-hover" src={javascript} alt="javascript"></img>
                    </div>
                </div>

                <div className="row text-center py-3">
                    <div
                        data-aos="fade-up"
                        className="col-md-3" >
                        <h5 className="text-secondary mb-3">MongoDB</h5>
                        <img width="100" className="img-fluid skill-hover" src={mongodb} alt="javascript"></img>
                    </div>
                    <div
                        data-aos="fade-up"
                        className="col-md-3">
                        <h5 className="text-secondary mb-3">Bootstrap</h5>
                        <img width="100" className="img-fluid skill-hover" src={bootstrap} alt="javascript"></img>
                    </div>
                    <div
                        data-aos="fade-up"
                        className="col-md-3">
                        <h5 className="text-secondary mb-3">HTML</h5>
                        <img width="100" className="img-fluid skill-hover" src={html} alt="javascript"></img>
                    </div>
                    <div
                        data-aos="fade-up"
                        className="col-md-3">
                        <h5 className="text-secondary mb-3">Git</h5>
                        <img width="100" className="img-fluid skill-hover" src={git} alt="javascript"></img>
                    </div>
                </div>

                <div className="row text-center py-3">
                    <div
                        data-aos="fade-up"
                        className="col-md-3">
                        <h5 className="text-secondary mb-3">Firebase</h5>
                        <img width="100" className="img-fluid skill-hover" src={firebase} alt="javascript"></img>
                    </div>
                    <div
                        data-aos="fade-up"
                        className="col-md-3">
                        <h5 className="text-secondary mb-3">Tailwind</h5>
                        <img width="100" className="img-fluid skill-hover" src={tailwind} alt="javascript"></img>
                    </div>
                    <div
                        data-aos="fade-up"
                        className="col-md-3">
                        <h5 className="text-secondary mb-3">React Router</h5>
                        <img width="100" className="img-fluid skill-hover" src={reactRouter} alt="javascript"></img>
                    </div>
                    <div
                        data-aos="fade-up"
                        className="col-md-3">
                        <h5 className="text-secondary mb-3">Heroku</h5>
                        <img width="100" className="img-fluid skill-hover" src={heroku} alt="javascript"></img>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Skills;